import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  blueButton: {
    ...theme.typography.labelTiny,
    background: '#10AFE2!important',
    padding: '8px 14px!important',
    borderRadius: '4px!important',
    textTransform: 'lowercase!important',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)!important',
    fontStyle: 'normal!important',
    fontWeight: '300!important',
    margin: '16px 5px!important',
    color: '#fff!important'
  },
  grayButton: {
    ...theme.typography.labelTiny,
    background: '#BBBBBB!important',
    padding: '8px 14px!important',
    borderRadius: '4px!important',
    textTransform: 'lowercase !important',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15) !important',
    fontStyle: 'normal!important',
    fontWeight: '300 !important',
    color: '#fff!important'
  },
  blueOutlineButton: {
    ...theme.typography.labelTiny,
    background: '#fff !important',
    padding: '8px 14px !important',
    borderRadius: '4px !important',
    textTransform: 'lowercase !important',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15) !important',
    fontStyle: 'normal!important',
    fontWeight: '300 !important',
    margin: '16px 0px!important',
    color: '#10AFE2 !important'
  },
  grayOutlineButton: {
    ...theme.typography.labelTiny,
    background: '#fff !important',
    padding: '8px 14px !important',
    borderRadius: '4px !important',
    textTransform: 'lowercase !important',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15) !important',
    fontStyle: 'normal!important',
    fontWeight: '300 !important',
    margin: '16px 0px!important',
    color: '#BBBBBB !important',
    border: '1px solid #BBBBBB'
  }
}));
